// ======================================================================
// File Name       : DistributionOfferListDetailCourseType
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';
import TableHead, { setSortState } from '../TableHead';
import PaginationCustom from '../Pagination';
import DateTimeWithValidate from '../DateTimeWithValidate';
import DateTimeMinMax from '../DateTimeMinMax';
import {
  MIN_DATE,
  MAX_DATE,
  MIN_MAX_DATE_TXT,
  WRONG_DISTRIBUTION_DATE_TXT,
  parseDateForDetail,
} from '../../utils/index';
import { DEFAULT_DATE_FORMAT } from '../../constants/index';
import CustomButton from '../button/CustomButton';

class DistributionOfferListDetailCourseType extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    this.refsToValidate = [];
    const {
      getStartEndData,
      recordNum,
      resetPage,
      onExportBtnClick,
      handleSortState,
      distributionCourseList,
      distributionStartDate,
      distributionEndDate,
      onInputChange,
      contentName,
      onSearchBtnClick,
      startPosition,
      courseName,
      dataSort,
    } = this.props;
    const startDate = distributionStartDate;
    const thead = [
      { title: 'コース名', sortBy: 1 },
      { title: '配布開始日', sortBy: 2, width: 170 },
      { title: '配布終了日', sortBy: 3, width: 170 },
    ];
    let data = thead;
    if (dataSort) {
      const sortBy = dataSort.distributionCourseSortType;
      const sortState = dataSort.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    const onChange = (event) => {
      const { name, value } = event.target;
      onInputChange(name, value);
    };
    const arrayTextContentType = ['ビデオ', 'ドリル', '問題', 'ドキュメント', '', 'リンク'];
    // table data
    let distributionTableData = null;
    if (distributionCourseList) {
      distributionTableData = distributionCourseList.map((distributionInfo, index) => (
        <tr key={index}>
          <td>{distributionInfo.courseName}</td>
          <td>
            {parseDateForDetail(
                distributionInfo.distributionStartDate,
                DEFAULT_DATE_FORMAT,
                MIN_MAX_DATE_TXT,
              )}
          </td>
          <td>
            {parseDateForDetail(
                distributionInfo.distributionEndDate,
                DEFAULT_DATE_FORMAT,
                MIN_MAX_DATE_TXT,
              )}
          </td>
        </tr>
        ));
    }
    return (
      <div>
        <Col sm={12} className="padding-left-clear">
          <Col sm={12}>
            <Form onSubmit={(e) => { e.preventDefault(); onSearchBtnClick(); }} className='form-horizontal'>
              <Form.Group className="form-info">
                <Col sm={3} className="margin-top-10">
                  コース名
                </Col>
                <Col sm={7} className="margin-top-5">
                  <FormControl
                    type="text"
                    name="courseName"
                    value={courseName}
                    onChange={onChange}
                    maxLength="256"
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={3} className="margin-top-15">
                  配布期間
                </Col>
                <Col sm={3}>
                  <DateTimeWithValidate
                    onChange={date => onInputChange('distributionStartDate', date)}
                    dateFormat={DEFAULT_DATE_FORMAT}
                    value={startDate}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
                <Col sm={1} className="text-center margin-top-5" as={Form.Label}>
                  ～
                </Col>
                <Col sm={3}>
                  <DateTimeWithValidate
                    onChange={date => onInputChange('distributionEndDate', date)}
                    dateFormat={DEFAULT_DATE_FORMAT}
                    value={distributionEndDate}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              </Form.Group>
              <Col sm={12}>
                <DateTimeMinMax
                  dateFrom={distributionStartDate}
                  dateTo={distributionEndDate}
                  wrongPeriodTxt={WRONG_DISTRIBUTION_DATE_TXT}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
              <Form.Group className="margin-top-10">
                <Col sm={12} className="text-center">
                  <CustomButton
                    btnStyle="btn btn-primary btn-96"
                    type="submit"
                    text="検索"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Form.Group>
            </Form>
          </Col>
        </Col>
        <Form.Group>
          <Col sm={12} className="padding-right-clear">
            {/* <Button bsStyle="primary" className="float-end btn-96" onClick={onExportBtnClick}>
              export
            </Button> */}
            <CustomButton
              btnStyle="btn btn-export-csv btn-96 float-end"
              handleClick={onExportBtnClick}
              text="一括出力"
              iconClass="bi bi-download"
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Col
            sm={12}
            className="margin-top-10 margin-bottom-10 padding-right-clear padding-left-clear"
          >
            <Col sm={6} className="padding-left-clear margin-top-5">
              <h5>配布コース一覧</h5>
            </Col>
          </Col>
        </Form.Group>
        <Table striped hover>
          <thead>
            <TableHead data={data} handleSortState={handleSortState} />
          </thead>
          <tbody>{distributionTableData}</tbody>
        </Table>
        <Col
          sm={12}
          className="margin-top-10 margin-bottom-10 padding-left-right-clear d-flex justify-content-center"
        >
          <PaginationCustom
            recordNum={recordNum}
            resetPage={resetPage}
            startPosition={startPosition}
            className="text-center margin-clear"
            handlePageSelect={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default DistributionOfferListDetailCourseType;
